import { Component } from '@angular/core';

@Component({
  selector: 'app-hire-talent-insights',
  templateUrl: './hire-talent-insights.component.html',
  styleUrl: './hire-talent-insights.component.scss',
  standalone:false
})
export class HireTalentInsightsComponent {

}
